import { Models } from "api/types";
import {
  CONCERN_CATEGORIES,
  ConcernCategoryName,
  GENDER_FILTERED_CONCERNS,
  getConcernCategoryTitle,
} from "modules/personalisation/constants/concernCategories";

export type ConcernItem = Models<"DisplayedConcern">;

export interface ConcernCategory {
  id: string;
  title: string;
}

export interface ConcernCategoryGroup {
  category: ConcernCategory;
  categoryConcerns: ConcernItem[];
}

export function groupConcernsByCategory(
  concerns: ConcernItem[],
  gender?: string | null,
): ConcernCategoryGroup[] {
  const filteredConcerns = filterConcernsByGender(concerns, gender);
  const groupedConcerns: ConcernCategoryGroup[] = [];

  Object.entries(CONCERN_CATEGORIES).forEach(([categoryName, concernNames]) => {
    const categoryConcerns = filteredConcerns.filter((concern) =>
      (concernNames as readonly string[]).includes(concern.name),
    );

    if (categoryConcerns.length > 0) {
      groupedConcerns.push({
        category: {
          id: categoryName.toLowerCase().replace(/\s+/g, "-"),
          title: getConcernCategoryTitle(categoryName as ConcernCategoryName),
        },
        categoryConcerns,
      });
    }
  });

  return groupedConcerns;
}

const filterConcernsByGender = (concerns: ConcernItem[], gender?: string | null): ConcernItem[] => {
  if (!gender) {
    return concerns;
  }

  return concerns.filter((concern) => {
    const filterRule =
      GENDER_FILTERED_CONCERNS[concern.name as keyof typeof GENDER_FILTERED_CONCERNS];

    if (!filterRule) {
      return true;
    }

    return filterRule.hiddenIf !== gender;
  });
};

export function getCategoryNameFromConcern(concernName: string): ConcernCategoryName | null {
  for (const [categoryName, concernNames] of Object.entries(CONCERN_CATEGORIES)) {
    if ((concernNames as readonly string[]).includes(concernName)) {
      return categoryName as ConcernCategoryName;
    }
  }
  return null;
}
